import styled, { keyframes } from "styled-components";
import StyledDiv from "../../../../StyledDiv/StyledDiv";

// Animations pour les nuages - mouvement horizontal aller-retour
const cloudMoveLeft = keyframes`
  0% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(-15px);
  }
  100% {
    transform: translateX(0);
  }
`;

const cloudMoveRight = keyframes`
  0% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(15px);
  }
  100% {
    transform: translateX(0);
  }
`;

const cloudMoveLeftReverse = keyframes`
  0% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(-20px);
  }
  100% {
    transform: translateX(0);
  }
`;

const cloudMoveRightReverse = keyframes`
  0% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(20px);
  }
  100% {
    transform: translateX(0);
  }
`;

// Composants stylisés pour les nuages avec animations
export const AnimatedCloudTopLeft = styled(StyledDiv)`
  animation: ${cloudMoveLeft} 10s ease-in-out infinite;
`;

export const AnimatedCloudTopRight = styled(StyledDiv)`
  animation: ${cloudMoveRight} 12s ease-in-out infinite;
  animation-delay: 1s;
`;

export const AnimatedCloudBottomLeft = styled(StyledDiv)`
  animation: ${cloudMoveLeftReverse} 11s ease-in-out infinite;
  animation-delay: 2s;
`;

export const AnimatedCloudBottomRight = styled(StyledDiv)`
  animation: ${cloudMoveRightReverse} 13s ease-in-out infinite;
  animation-delay: 3s;
`;
